var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShortArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6046 7.60457C22.9385 7.27068 22.9385 6.72932 22.6046 6.39542L17.1634 0.954235C16.8295 0.620337 16.2881 0.620337 15.9542 0.954235C15.6203 1.28813 15.6203 1.82949 15.9542 2.16339L20.7908 7L15.9542 11.8366C15.6203 12.1705 15.6203 12.7119 15.9542 13.0458C16.2881 13.3797 16.8295 13.3797 17.1634 13.0458L22.6046 7.60457ZM7.47465e-08 7.855L22 7.855L22 6.145L-7.47465e-08 6.145L7.47465e-08 7.855Z",
    fill: "#F8B400"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortArrow);
export default __webpack_public_path__ + "static/media/short-arrow.44c274129c85da8619453459a20a71ee.svg";
export { ForwardRef as ReactComponent };